import clsx from 'clsx'
import { RANK_CONFIG } from '../../data/mock'
import type { Rank } from '../../types'

interface AvatarProps {
  name: string
  size?: 'sm' | 'md' | 'lg'
  rank?: Rank
  isOnline?: boolean
  className?: string
}

const sizeMap = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-20 h-20 text-2xl',
}

const statusSizeMap = {
  sm: 'w-3 h-3 border',
  md: 'w-3.5 h-3.5 border-2',
  lg: 'w-5 h-5 border-2',
}

function getInitials(name: string): string {
  return name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()
}

function getAvatarColor(name: string): string {
  const colors = ['#5865F2', '#57F287', '#FEE75C', '#EB459E', '#ED4245', '#F47FFF', '#E67E22', '#3BA55C']
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return colors[Math.abs(hash) % colors.length]
}

export default function Avatar({ name, size = 'md', rank, isOnline, className }: AvatarProps) {
  const borderColor = rank ? RANK_CONFIG[rank]?.color : undefined

  return (
    <div className={clsx('relative inline-flex shrink-0', className)}>
      <div
        className={clsx('rounded-full flex items-center justify-center font-semibold', sizeMap[size])}
        style={{
          backgroundColor: getAvatarColor(name),
          border: borderColor ? `2px solid ${borderColor}` : undefined,
        }}
      >
        {getInitials(name)}
      </div>
      {isOnline !== undefined && (
        <span
          className={clsx(
            'absolute bottom-0 right-0 rounded-full bg-surface-tertiary',
            statusSizeMap[size],
          )}
        >
          <span
            className="block w-full h-full rounded-full"
            style={{ backgroundColor: isOnline ? 'var(--status-online)' : 'var(--text-muted)' }}
          />
        </span>
      )}
    </div>
  )
}
